export default "__VITE_ASSET__BsrmEQsz__"